import { isEmptyDocument } from 'datocms-structured-text-utils'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useGetMarketplaceCompanyInstallations } from 'modules/marketplace/hooks/integrations/companyInstallations/useGetMarketplaceCompanyInstallations'
import { useGetMarketplaceFormQuestions } from 'modules/marketplace/hooks/integrations/formQuestions/useGetMarketplaceFormQuestions'
import { usePaywall } from 'modules/marketplace/hooks/usePaywall'
import { useMarketplaceUserPermissions } from 'modules/marketplace/hooks/useUserPermissions'

export const useShowIntegrationSettings = (integration?: ItemIntegrationFragment) => {
  const { installable, id, setupInformation } = integration || {}
  const { canInstallCompanyWideIntegration } = useMarketplaceUserPermissions()
  const { access, company } = useCurrentSession()
  const { showPaywall, loading: featureAvailabilityLoading } = usePaywall(integration)

  const { data: companyInstallationsData, loading: loadingCompanyInstallations } =
    useGetMarketplaceCompanyInstallations(
      {
        // FIXME: We should arrange the components to call this hook only when there is an id
        integrationIds: [id ?? '0'],
      },
      !installable
    )

  const { data: formQuestionsData, loading: loadingFormQuestions } = useGetMarketplaceFormQuestions(
    {
      integrationId: id || '-1',
      companyId: company.id,
      accessId: access.id,
    },
    !installable
  )

  const questionPropertiesPresent = () => {
    if (formQuestionsData.at(0)) {
      const parsedFormQuestions = JSON.parse(formQuestionsData.at(0)?.formQuestions || '{}')
      return Object.keys(parsedFormQuestions).length > 0
    } else {
      return false
    }
  }

  const loading = loadingCompanyInstallations || loadingFormQuestions || featureAvailabilityLoading
  const installationPresent = companyInstallationsData.length === 1

  const installedIntegrationWithQuestions = () => {
    if (!installable) return false
    if (installationPresent && questionPropertiesPresent()) return true
    return false
  }

  const informativeIntegrationWithSetup = () => {
    if (showPaywall) return false
    if (installable) return false
    return !isEmptyDocument(setupInformation ? JSON.parse(setupInformation) : null)
  }

  if (
    !loading &&
    canInstallCompanyWideIntegration &&
    (installedIntegrationWithQuestions() || informativeIntegrationWithSetup())
  )
    return true
  return false
}
